export const orderQuery = (order: 'ascend' | 'descend', sortField: { sort: string }) => {
  return order === 'ascend' ? sortField : { sort: `-${sortField.sort}` };
};
